import { ReactNode } from 'react';
import styles from './Link.module.css';

const SIZES = [
  'x-large',
  'large',
  'm-large',
  'm-small',
  'small',
  'x-small',
] as const;

type LinkProps = {
  link: string;
  children: ReactNode;
  disabled?: boolean;
  size?: (typeof SIZES)[number];
  upperCase?: boolean;
};

const Link = ({
  link,
  children,
  size = 'small',
  upperCase = false,
  disabled = false,
}: LinkProps) => (
  <a
    href={link}
    target='_blank'
    rel='noreferrer'
    className={`${styles.link} ${styles[size]} ${upperCase ? styles.uppercase : ''} ${disabled ? styles.disabled : ''}`}
  >
    {children}
  </a>
);

export default Link;
